/* eslint-disable react/destructuring-assignment */
import React from 'react';
import contact from '../../images/siteHeader.png';

const ContactBanner = (props) => (
  <div
    className="centerCropped"
    style={{ backgroundImage: `url(${contact})`, ...props.style }}
  />
);

export default ContactBanner;
